import React, { useState } from 'react';

function Counter() {
  const [count, setCount] = useState(0);

  const styles = {
    container: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100vh',
      textAlign: 'center',
      backgroundColor: 'white'
    },
    outerBox: {
      border: '3px solid #004080',
      padding: '50px',
      borderRadius: '20px',
      boxShadow: '0 0 15px rgba(0, 0, 0, 0.1)',
      backgroundColor: '#ffffff',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center'
    },
    buttons: {
      display: 'flex',
      gap: '10px'
    },
    button: {
      padding: '10px 20px',
      fontSize: '1rem',
      backgroundColor: '#007BFF',
      color: 'white',
      border: 'none',
      borderRadius: '5px',
      cursor: 'pointer'
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.outerBox}>
        <h1 style={{ color: '#004080' }}>Counter App</h1>
        <div style={{
          fontSize: '3rem',
          color: 'green',
          margin: '20px 0',
          width: '100px',
          textAlign: 'center'
        }}>
          {count}
        </div>
        <div style={styles.buttons}>
          <button style={styles.button} onClick={() => setCount(count - 1)}>-</button>
          <button style={styles.button} onClick={() => setCount(0)}>Reset</button>
          <button style={styles.button} onClick={() => setCount(count + 1)}>+</button>
        </div>
      </div>
    </div>
  );
}

export default Counter;
